import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import CustomerReceiptTable from './shared/CustomerReceiptTable';
import { useState } from 'react';
import CreateCustomerReceipt from './shared/CreateCustomerReceipt';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const CustomerReceipt = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CreateCustomerReceipt handleApiCall={handleApiCall} />
            <CustomerReceiptTable apiCall={apiCall} handleApiCall={handleApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default CustomerReceipt;
